module.exports = __webpack_public_path__ + "media/stylesheets/images/temp_wolf_planent_kit/card_kit_5-e5ddfa16c3f2e6f6cd448bfc3b34fa98.png";